module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Laptop-a5823156098e7d8fca1ebded6e716338.svg";